module.exports = __webpack_public_path__ + "static/assets/c9efe7ba07f7df47a75de89aaefbc043.png";